import type { AcquirerEntity } from "src/app/features/Acquirer/types/AcquirerEntity";
import type { AcquirerContractDto } from "src/app/features/Acquirer/types/subTypes/AcquirerContractDto";
import type { AcquirerDto } from "../../types/AcquirerDto";
import { AcquirerToVirtualEntityToDto } from "./AcquirerToVirtualEntityToDto";

export const AcquirerPhysicalEntityToDto = ({
    contracts,
    hostDeviceIdMaskEdit,
    hostDeviceIdMaskGenerate,
    acquirersToVirtual,
    ...rest
}: Readonly<AcquirerEntity>): AcquirerDto => {
    const newContracts: AcquirerContractDto[] =
        contracts?.map((contract) => ({
            id: contract.id,
            contractNumber: contract.contractNumber,
            siteName: contract.siteName,
            validFrom: contract.validFrom,
            validTo: contract.validTo,
            changed: contract.changed,
        })) ?? [];

    const newHostOperators = rest.hostOperators?.map(({ rowId: _rowId, ...hostOperators }) => hostOperators);

    const newHostDeviceIdMaskEdit = hostDeviceIdMaskEdit && hostDeviceIdMaskEdit !== "" ? hostDeviceIdMaskEdit : undefined;
    const newHostDeviceIdMaskGenerate = hostDeviceIdMaskGenerate && hostDeviceIdMaskGenerate !== "" ? hostDeviceIdMaskGenerate : undefined;

    const acquirersToVirtualDto = acquirersToVirtual?.map(AcquirerToVirtualEntityToDto) ?? [];

    return {
        ...rest,
        hostDeviceIdMaskEdit: newHostDeviceIdMaskEdit,
        hostDeviceIdMaskGenerate: newHostDeviceIdMaskGenerate,
        contracts: newContracts,
        acquirersToVirtual: acquirersToVirtualDto,
        hostOperators: newHostOperators,
    };
};
